import { Button, message } from 'antd';
import axios from 'axios';
import React, { useEffect } from 'react';
import API from '../../../config/axios.config';
import { environment } from '../../../environments/environment';
import { API_ENDPOINTS } from '../../../shared/api-endpoints';

const Health = () => {
	// useEffect(() => {

	// }, []);

	const statuscheck = () => {
		axios
			// .get('https://appservice-webapp-dev.azurewebsites.net/api/Status/Check')
			.get(`${environment.APP_API_URL}${API_ENDPOINTS.STATUS_CHECK}`)
			.then((response:any) => {
				if (response?.status === 200) {
					message.success(response?.data);
				} else if (response?.status === 400 || response?.status === 500) {
					message.error(response?.data);
				}
			})
			.catch((err) => {
				if (err?.response) {
					message.error(err.response.data);
				} else {
					message.error('An unexpected error occurred');
				}
			});
	};
	const ConnectionCheck = () => {
		axios
			// .get('https://appservice-webapp-dev.azurewebsites.net/api/OAuth/CheckConnection')
      .get(`${environment.APP_API_URL}${API_ENDPOINTS.CONNECTION}`)
			.then((response:any) => {
				if (response?.status === 200) {
					message.success(response?.data?.message);
				} else if (response?.statusCode === 400 || response?.statusCode === 500) {
					message.error(response?.message);
				}
			})
			.catch((err:any) => {
				if (err?.response) {
					message.error(err?.response?.data);
				} else {
					message.error('An unexpected error occurred');
				}
			});
	};

	return (
		<div style={{ height: '100%' }} className="gx-d-flex gx-align-items-center gx-justify-content-center gx-fs-lg">
			<div style={{textAlign:"center"}}>
				Health Checkup
				<div className='gx-mt-2'>
					<Button onClick={statuscheck}>Status Check</Button>
					<Button onClick={ConnectionCheck}>Connection Check</Button>
				</div>
			</div>
		</div>
	);
};

export default Health;
